var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"appRadioGroup"},[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.items),function(item,index){return _c('v-radio',{key:index,staticClass:"appRadioGroup-item",attrs:{"label":item.label,"value":item.value,"color":"#CC0000"}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }